import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<CreateIndex @formData={{@model.formData}} @poll={{@model.poll}} />",{ moduleName: "@croodle/client/templates/create/index.hbs" })